import {
  getRequest,
  postRequest,
  deleteRequestWithBody,
} from "./requestClient";

export function generatePresignedUrl(
  params: AppAPI.GeneratePresignedUrlParams,
) {
  return postRequest<AppAPI.GeneratePresignedUrlResponse>(
    "/oss/generate-signature-url",
    params,
  );
}

export function getDownloadUrl(fileKey: string) {
  return postRequest<AppAPI.Response<{ fileKey: string; downloadUrl: string }>>(
    "/oss/get-download-url",
    {
      fileKey,
    },
  );
}
